import { FORTA_WHITE } from '../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const FH_PREVIEW_DIALOG_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  mb: 1.5,
  backgroundColor: FORTA_WHITE,
};

export const FH_PREVIEW_DIALOG_CONTENT_SX: SxProps<Theme> = {
  borderRadius: '8px',
  overflowY: 'auto',
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
